import { all, takeLatest, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../../admincore'

import { detailLabel } from '../../../api'
import actions, { load } from './actions'

let cachedParams = null

function* LOAD({ payload: { id } }) {
  cachedParams = id
  const companySelect = localStorage.getItem('app.settings.company')

  console.log('id', id)
  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(detailLabel(companySelect, id), actions.LOAD))
}

function* REFRESH() {
  if (cachedParams) {
    yield put(load(cachedParams))
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actions.LOAD, LOAD), takeEvery('labels/update/success', REFRESH)])
}
